import React from 'react';

export default function PayrollHistory() {
  return (
    <div>payrollHistory</div>
  );
}
